import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "order-audit"
};
const _hoisted_2 = {
  key: 0,
  class: "header"
};
const _hoisted_3 = {
  class: "switch"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "APP端开启售后入口", -1);

const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "info",
  style: {
    "margin-left": "10px",
    "color": "#999",
    "font-size": "12px"
  }
}, "订单完成后订单列表页面提供售后入口自主申请", -1);

const _hoisted_6 = {
  class: "header"
};
const _hoisted_7 = {
  class: "switch"
};

const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "开启审核", -1);

const _hoisted_9 = {
  key: 0,
  class: "info",
  style: {
    "margin-left": "10px",
    "color": "#999",
    "font-size": "12px"
  }
};
const _hoisted_10 = {
  class: "card verify-rule"
};

const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-title"
}, "审批条件", -1);

const _hoisted_12 = {
  class: "select"
};
const _hoisted_13 = {
  class: "item"
};

const _hoisted_14 = /*#__PURE__*/_createTextVNode("无条件审核（所有订单均需审核）");

const _hoisted_15 = {
  class: "item"
};

const _hoisted_16 = /*#__PURE__*/_createTextVNode("满足条件审核");

const _hoisted_17 = {
  class: "item-select-list"
};
const _hoisted_18 = {
  class: "item-select"
};
const _hoisted_19 = {
  class: "item-select-content"
};

const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "订单金额满", -1);

const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "元", -1);

const _hoisted_22 = {
  class: "item-select customer-type-row"
};
const _hoisted_23 = {
  class: "item-select-content"
};

const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "订单中客户类型", -1);

const _hoisted_25 = {
  class: "item-select"
};
const _hoisted_26 = {
  class: "item-select-content"
};

const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "订单含所选品种即审核", -1);

const _hoisted_28 = /*#__PURE__*/_createTextVNode("选择");

const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", {
  class: "item-select"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, "若设置审核金额即订单中商品实付总额达到设置金额触发审核")], -1);

const _hoisted_30 = {
  style: {
    "margin-top": "10px"
  }
};

const _hoisted_31 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "red",
    "margin-left": "16px",
    "font-size": "12px",
    "white-space": "nowrap",
    "vertical-align": "middle"
  }
}, "审核金额或审核数量若为0，即提交订单后不触发审核", -1);

const _hoisted_33 = {
  class: "card verify-person"
};

const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-title"
}, [/*#__PURE__*/_createTextVNode(" 审批人设置 "), /*#__PURE__*/_createElementVNode("span", {
  class: "info",
  style: {
    "color": "red",
    "font-size": "12px",
    "margin-top": "10px",
    "font-weight": "500"
  }
}, "请确认审批人已配置订单审核菜单权限，否则APP无入口进入")], -1);

const _hoisted_35 = /*#__PURE__*/_createTextVNode("团队管理者审核");

const _hoisted_36 = /*#__PURE__*/_createTextVNode("自定义审核人");

const _hoisted_37 = {
  key: 1,
  class: "verify-person-manager"
};

const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, "按下单时的管理结构与管理者进行审核", -1);

const _hoisted_39 = /*#__PURE__*/_createTextVNode("一级团队管理者审核");

const _hoisted_40 = /*#__PURE__*/_createTextVNode("直属团队管理者审核");

const _hoisted_41 = /*#__PURE__*/_createTextVNode("按团队层级逐级（管理者）审核，适用于多层级团队层层审核场景");

const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, [/*#__PURE__*/_createElementVNode("p", null, "说明："), /*#__PURE__*/_createElementVNode("p", null, "1.对应团队无管理者将会自动通过"), /*#__PURE__*/_createElementVNode("p", null, "2.若团队有多个管理者，任一管理者审核通过即可")], -1);

const _hoisted_43 = {
  key: 2,
  class: "verify-person-custom"
};
const _hoisted_44 = {
  class: "person-item"
};
const _hoisted_45 = {
  class: "person-card"
};

const _hoisted_46 = /*#__PURE__*/_createTextVNode("选择审批人");

const _hoisted_47 = {
  class: "person-names"
};
const _hoisted_48 = {
  class: "extra"
};

const _hoisted_49 = /*#__PURE__*/_createTextVNode("删除此级审批层");

const _hoisted_50 = /*#__PURE__*/_createTextVNode("增加下级审批层");

const _hoisted_51 = {
  class: "person-card"
};

const _hoisted_52 = /*#__PURE__*/_createTextVNode("选择审批人");

const _hoisted_53 = {
  class: "person-names"
};
const _hoisted_54 = {
  class: "card verify-person-white"
};

const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-title"
}, "无需审核客户", -1);

const _hoisted_56 = {
  class: "toolbox"
};

const _hoisted_57 = /*#__PURE__*/_createTextVNode("添加");

const _hoisted_58 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_59 = /*#__PURE__*/_createTextVNode("保存");

const _hoisted_60 = /*#__PURE__*/_createElementVNode("p", null, "1. 请下载Excel模版，填写用户信息，保存后上传到系统", -1);

const _hoisted_61 = /*#__PURE__*/_createElementVNode("p", null, "2. 最多可导入1000条信息", -1);

const _hoisted_62 = /*#__PURE__*/_createElementVNode("p", null, "3. 不可输入特殊符号，如“*”", -1);

const _hoisted_63 = /*#__PURE__*/_createElementVNode("p", null, "4. 站点和客户编码都为必填项，若未填则保存不成功", -1);

const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "red",
    "margin-bottom": "10px"
  }
}, "存在待审核订单，无法进行变更操作。若审核人无法审核，请联系平台客服。", -1);

const _hoisted_65 = /*#__PURE__*/_createTextVNode("确定");

import { reactive, ref, watch, computed } from 'vue';
import { getVexTableProps } from '@/config';
import { useRoute, useRouter } from 'vue-router';
import { getOrderAuditDivId, getOrderauditMerchandise, getOrderCustomer, getAuditPriceId, updateOrderAutidDivId, deleteByAuditMainId, deleteOrderAutidDivId, deleteOrderCustomer } from '@/request';
import { execlImportCustomer, importCustomerExcel } from '@/request/api';
import { saveOrderAuditInfo, getOrderAuditInfo, getCustomerTypeList } from '@/request'; // apiOverrides 允许外部覆盖默认接口

import { ElMessage, ElMessageBox } from 'element-plus';
import UploadModal from '@/components/UploadModal.vue';
import AddPersonAuditModal from './component/AddPersonAuditModal.vue';
import AddProductModal from './component/AddProductModal.vue';
import AddCustomerModal from './component/AddCustomerModal.vue';
import AddSalesmanModal from './component/AddSalesmanModal.vue';
export default {
  name: 'OrderAudit@3.0',
  props: {
    actDept: [null, Object],
    customAuditType: {
      type: Number,
      default: null
    },
    apiOverrides: {
      type: Object,
      default: () => ({})
    }
  },

  setup(__props) {
    const props = __props;

    const _saveOrderAuditInfo = params => (props.apiOverrides.saveOrderAuditInfo || saveOrderAuditInfo)(params);

    const _getOrderAuditInfo = params => (props.apiOverrides.getOrderAuditInfo || getOrderAuditInfo)(params);

    const state = reactive({
      thisCustKeyWord: '',
      isAuditTotalprice: 0,
      limit_price: 0,
      auditPriceId: ''
    });
    const route = useRoute();
    const router = useRouter();
    const supplierId = ref(props.actDept.supplierId).value; // @3.0 新加入参

    const auditParams = {
      auditType: Number(route.query.storeType) === 1 ? 2 : 1,
      factorySupplierId: props.actDept.factorySupplierId,
      factoryStructureId: props.actDept.levelType === '1' ? '' : props.actDept.factoryStructureId
    }; // 5.4.0

    const auditMainId = ref(''); // 审核开启状态

    const orderAuditStatus = ref(false); // APP端开启售后入口

    const refundOpenEntry = ref(false); // 审核条件配置

    const auditConditionInfo = reactive({
      isAuditCondition: 0,
      // 是否有审核条件
      isAuditOrderPrice: 0,
      // 是否有审核订单金额
      orderLimitPrice: 0,
      // 订单审核金额
      isAuditProdPrice: 0,
      // 是否有审核商品金额
      isAuditCustType: 0,
      // 是否审核客户类型
      custTypeList: [],
      // 审核客户类型列表
      prodInfoList: [] // 审核商品列表

    });
    const customerTypeOptions = ref([]);

    function getCustomerTypeOptions() {
      getCustomerTypeList({
        page: 1,
        rows: 999
      }).then(res => {
        const rows = Array.isArray(res === null || res === void 0 ? void 0 : res.rows) ? res.rows : [];
        customerTypeOptions.value = rows.map(item => {
          var _item$dictitemCode;

          return {
            label: item.dictitemName || item.dictitemname || item.custTypeName || '',
            value: Number((_item$dictitemCode = item.dictitemCode) !== null && _item$dictitemCode !== void 0 ? _item$dictitemCode : item.custTypeId)
          };
        }).filter(item => item.label && Number.isFinite(item.value));
      });
    } // 审核人配置


    const auditorConfigInfo = reactive({
      auditorType: auditParams.factorySupplierId ? 0 : 1,
      // 审核人类型
      supplierAuditorType: 1,
      // 团队审核人类型
      auditorInfoList: [{}] // 自定义审核人列表

    }); // 白名单客户列表

    const whiteCustInfoList = ref([]);

    function addProductHandle(list) {
      let prodNos = auditConditionInfo.prodInfoList.map(v => v.prodNo);
      let prodList = list.map(item => {
        if (prodNos.find(prodNo => item.prodNo == prodNo)) return undefined;
        return {
          branchName: item.shortName,
          prodNo: item.prodNo,
          prodName: item.prodName,
          prodSpecification: item.proSpec,
          manufacturer: item.manufacture,
          prodLimitPrice: 0,
          prodLimitNum: 0
        };
      }).filter(v => v);
      auditConditionInfo.prodInfoList = auditConditionInfo.prodInfoList.concat(prodList);
    }

    const selectedProdList = ref([]);

    function removeProdHandle() {
      if (selectedProdList.value.length === 0) {
        ElMessage.warning('请勾选品种后再进行操作');
        return;
      }

      let selectedProdNos = selectedProdList.value.map(v => v.prodNo);
      auditConditionInfo.prodInfoList = auditConditionInfo.prodInfoList.filter(v => {
        return !selectedProdNos.find(prodNo => v.prodNo == prodNo);
      });
    }

    const auditPersonModalShow = ref(false);
    const auditPersonCurrenIndex = ref(0);
    const auditPersonModalMode = computed(() => {
      return auditParams.factorySupplierId ? 'single' : 'multiple';
    });

    function addAuditPerson(item, index) {
      auditPersonCurrenIndex.value = index;
      auditPersonModalShow.value = true;
    }

    function addAuditPersonLevel(item, i) {
      auditorConfigInfo.auditorInfoList.push({});
    }

    function removeAuditPersonLevel(index) {
      auditorConfigInfo.auditorInfoList.splice(index, 1);
    }

    function auditPersonSuccess(reviewer, list) {
      let personObj = {
        userNames: list.map(v => v.linkMan).join(),
        supUserIds: list.map(v => v.supUserId).join()
      };
      let target = auditorConfigInfo.auditorInfoList[auditPersonCurrenIndex.value];
      auditorConfigInfo.auditorInfoList[auditPersonCurrenIndex.value] = _objectSpread({}, personObj);
    }

    function addWhitePersonSuccess(list) {
      let whiteCustIds = whiteCustInfoList.value.map(v => v.custId);
      let custList = list.map(v => {
        if (whiteCustIds.find(custId => v.erpCustId == custId)) return undefined;
        return {
          custId: v.erpCustId,
          custName: v.custName
        };
      }).filter(v => v);
      whiteCustInfoList.value = whiteCustInfoList.value.concat(custList);
    }

    const selectedWhiteCustList = ref([]);

    function removeWhitePerson() {
      let selectedWhiteCustIds = selectedWhiteCustList.value.map(v => v.custId);
      whiteCustInfoList.value = whiteCustInfoList.value.filter(v => {
        return !selectedWhiteCustIds.find(custId => v.custId == custId);
      });
    }

    const errorModalShow = ref(false);
    const errorModalData = ref([]);

    function submit() {
      if (orderAuditStatus.value) {
        let flag = true;
        auditorConfigInfo.auditorInfoList.forEach((item, index) => {
          item.auditLevel = index + 1;

          if (!item.supUserIds) {
            flag = false;
          }
        });

        if (!flag && auditorConfigInfo.auditorType == 0) {
          ElMessage.error('请选择审批人');
          return;
        }
      } // 当选择“订单含所选品种即审核”时，校验每个品种的审核金额与审核数量是否同时为0


      if (auditConditionInfo.isAuditCondition == 1 && auditConditionInfo.isAuditProdPrice) {
        const invalidProdItem = auditConditionInfo.prodInfoList.find(p => {
          const price = Number(p.prodLimitPrice || 0);
          const num = Number(p.prodLimitNum || 0);
          return price === 0 && num === 0;
        });

        if (invalidProdItem) {
          const name = invalidProdItem.prodName || '该商品';
          ElMessage.error(name + ' 商品审核金额与数量不可均为0');
          return;
        }
      }

      if (auditConditionInfo.isAuditCondition == 1 && auditConditionInfo.isAuditCustType) {
        if (!auditConditionInfo.custTypeList.length) {
          ElMessage.error('请选择客户类型');
          return;
        }
      }

      let body = {
        auditMainId: auditMainId.value,
        supplierId,
        factorySupplierId: auditParams.factorySupplierId,
        factoryStructureId: auditParams.factoryStructureId,
        orderAuditStatus: orderAuditStatus.value ? 1 : 0,
        refundOpenEntry: refundOpenEntry.value ? 1 : 0,
        auditConditionInfo: auditConditionInfo,
        auditorConfigInfo: _objectSpread({}, auditorConfigInfo),
        whiteCustInfoList: whiteCustInfoList.value
      };

      if (body.auditorConfigInfo.auditorType === 1) {
        body.auditorConfigInfo.auditorInfoList = [];
      }

      _saveOrderAuditInfo(body).then(res => {
        let {
          success,
          msg,
          data = []
        } = res;

        if (success) {
          ElMessage.success('操作成功');
        } else {
          if (data.length) {
            errorModalData.value = data;
            errorModalShow.value = true;
          } else {
            ElMessage.error(msg);
          }
        }
      }).then(() => getData());
    }

    function getData() {
      let params = _objectSpread({
        supplierId
      }, auditParams);

      delete params.auditType;

      _getOrderAuditInfo(params).then(res => {
        if (!res.success) return;
        let resData = res.data; // let { auditMainId, orderAuditStatus, auditConditionInfo, auditorConfigInfo, whiteCustInfoList } = res

        auditMainId.value = resData.auditMainId;
        orderAuditStatus.value = resData.orderAuditStatus ? true : false;
        refundOpenEntry.value = resData.refundOpenEntry ? true : false;

        if (resData.auditConditionInfo) {
          Object.keys(auditConditionInfo).forEach(key => {
            if (resData.auditConditionInfo[key] != undefined) {
              if (key === 'orderLimitPrice') {
                auditConditionInfo[key] = parseFloat(resData.auditConditionInfo[key]);
              } else if (key === 'custTypeList') {
                auditConditionInfo[key] = Array.isArray(resData.auditConditionInfo[key]) ? resData.auditConditionInfo[key].map(v => Number(v)).filter(v => Number.isFinite(v)) : [];
              } else {
                auditConditionInfo[key] = resData.auditConditionInfo[key];
              }
            }
          });
        }

        if (resData.auditorConfigInfo) {
          Object.keys(auditorConfigInfo).forEach(key => {
            if (resData.auditorConfigInfo[key] != undefined) {
              auditorConfigInfo[key] = resData.auditorConfigInfo[key];
            }
          });
        }

        resData.whiteCustInfoList && (whiteCustInfoList.value = resData.whiteCustInfoList);
      });
    }

    getCustomerTypeOptions();
    getData();
    watch(() => auditConditionInfo.isAuditCustType, v => {
      if (!v) {
        auditConditionInfo.custTypeList = [];
      }
    });

    function isAuditOrderPriceChange(v) {
      if (v == 0) {
        auditConditionInfo.prodInfoList = [];
      }
    }

    const personTable = ref();
    const orderTable = ref();
    const unAuditTable = ref();
    const uploadOption = {
      action: execlImportCustomer.url + '?supplierId=' + supplierId,
      name: 'customerExcel',
      templateLink: importCustomerExcel.url,
      title: '导入'
    };
    const showUploadModel = ref(false); // const auditMainId = ref();

    const showAddPersonAuditModal = ref(false);
    const showAddProductModal = ref(false);
    const showAddCustomerModal = ref(false);

    function addPersonAuditSuccess() {
      personTable.value.commitProxy('reload');
    }

    function addPerson() {
      auditMainId.value = null;
      showAddPersonAuditModal.value = true;
    }

    function delPeronAudit() {
      const selectRows = personTable.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      ElMessageBox.confirm(`删除操作可能会影响部分数据的计算，请谨慎操作，确定要删除这${selectRows.length}条数据吗`, '确认删除?').then(() => {
        deleteByAuditMainId({
          __repeat: true,
          __warn: true
        }, {
          params: {
            auditMainIds: selectRows.map(i => i.auditMainId).join(',')
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            personTable.value.commitProxy('reload');
          }
        });
      });
    }

    function delUnAuditCustomer() {
      const selectRows = unAuditTable.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      ElMessageBox.confirm(`删除操作可能会影响部分数据的计算，请谨慎操作，确定要删除这${selectRows.length}条数据吗`, '确认删除?').then(() => {
        deleteOrderCustomer({
          __repeat: true,
          __warn: true
        }, {
          params: {
            customerIds: selectRows.map(i => i.customerId).join(',')
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            unAuditTable.value.commitProxy('reload');
          }
        });
      });
    }

    function uploadSuccess(data) {
      showUploadModel.value = false;

      if (data.success) {
        unAuditTable.value.commitProxy('reload');
        ElMessage.success('操作成功!');
      }
    }

    function updatePeronAudit(row) {
      auditMainId.value = row.auditMainId;
      showAddPersonAuditModal.value = true;
    }

    function deleteOrder() {
      const selectRows = orderTable.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      ElMessageBox.confirm(`删除操作可能会影响部分数据的计算，请谨慎操作，确定要删除这${selectRows.length}条数据吗`, '确认删除?').then(() => {
        deleteOrderAutidDivId({
          __repeat: true,
          __warn: true
        }, {
          params: {
            auditMerchandiseIds: selectRows.map(i => i.auditMerchandiseId).join(',')
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            orderTable.value.commitProxy('reload');
          }
        });
      });
    } // 初始化价格配置信息
    // getAuditPriceId({
    //   supplierId,
    //   ...auditParams
    // }).then((data) => {
    //   if (data.success && data.data) {
    //     state.limit_price = data.data.limitPrice;
    //     state.isAuditTotalprice = data.data.isAuditTotalprice;
    //     state.auditPriceId = data.data.auditPriceId;
    //   }
    // });


    function goBack() {
      router.replace({
        name: route.query.from
      });
    }

    function save() {
      const {
        fullData
      } = orderTable.value.getTableData();
      let auditPersonData = personTable.value.getTableData();
      /**
       *  人员审核（必填）缺失提示：“请设置人员审核信息”；
          当订单金额选择不需要审核时，需校验订单品种信息，缺失提示：“请设置订单金额或者订单品种信息”；
          当订单金额选择需要审核时，不需要校验订单品种信息；
       */

      if (auditPersonData.fullData.length === 0) {
        ElMessage.error('请设置人员审核信息');
        return false;
      }

      if (state.isAuditTotalprice === 0 && fullData.length === 0) {
        ElMessage.error('请设置订单金额或者订单品种信息');
        return false;
      }

      if (fullData.some(v => v.limitPrice == null)) {
        ElMessage.error('请设置审核金额');
        return false;
      }

      return updateOrderAutidDivId(_objectSpread(_objectSpread({
        auditPriceId: state.auditPriceId,
        supplierId,
        isAuditTotalprice: state.isAuditTotalprice,
        limitPrice: state.isAuditTotalprice === 0 ? 0 : state.limit_price,
        auditMerchandiseIds: fullData.map(item => item.auditMerchandiseId).join(','),
        limitPrices: fullData.map(item => item.limitPrice).join(',')
      }, auditParams), {}, {
        __repeat: true,
        __warn: true
      })).then(data => {
        if (data.success) {
          ElMessage.success('保存成功!');
          goBack();
        }
      });
    }

    const personTableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '审核人',
        field: 'reviewer',
        width: '400px',
        showOverflow: true
      }, {
        title: '被审核人',
        field: 'auditee',
        showOverflow: true
      }, {
        title: '操作',
        width: '100px',
        fixed: 'right',
        slots: {
          default: 'operation'
        }
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getOrderAuditDivId(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize,
              supplierId
            }, auditParams)).then(data => {
              var _data$rows;

              data === null || data === void 0 ? void 0 : (_data$rows = data.rows) === null || _data$rows === void 0 ? void 0 : _data$rows.forEach(item => {
                if (item.isAuditAll === 1) {
                  // 如果是全部审核
                  item.auditee = 'ALL';
                }
              });
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });
    const orderTableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '发货方',
        field: 'shortName',
        width: '150px',
        showOverflow: true
      }, {
        title: '编码',
        field: 'prodNo',
        width: '200px',
        showOverflow: true
      }, {
        title: '名称',
        field: 'prodName',
        width: '200px',
        showOverflow: true
      }, {
        title: '审核金额',
        field: 'limitPrice',
        width: '180px',
        showOverflow: true,
        slots: {
          default: 'price'
        }
      }, {
        title: '审核数量',
        field: 'limitNum',
        width: '180px',
        showOverflow: true
      }, {
        title: '规格',
        field: 'proSpec',
        width: '150px',
        showOverflow: true
      }, {
        title: '厂家',
        field: 'manufacture',
        width: '200px',
        showOverflow: true
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getOrderauditMerchandise(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize,
              supplierId
            }, auditParams)).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });
    const unAuditTableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '客户Id',
        field: 'custId',
        width: '200px',
        showOverflow: true
      }, {
        title: '客户名称',
        field: 'custName',
        showOverflow: true
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getOrderCustomer(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize,
              supplierId,
              thisCustKeyWord: state.thisCustKeyWord
            }, auditParams)).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_switch = _resolveComponent("el-switch");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_timeline_item = _resolveComponent("el-timeline-item");

      const _component_el_timeline = _resolveComponent("el-timeline");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.customAuditType === 3 && !auditParams.factorySupplierId ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_switch, {
        modelValue: refundOpenEntry.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => refundOpenEntry.value = $event),
        style: {
          "margin-left": "10px"
        }
      }, null, 8, ["modelValue"]), _hoisted_5])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_switch, {
        modelValue: orderAuditStatus.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => orderAuditStatus.value = $event),
        style: {
          "margin-left": "10px"
        }
      }, null, 8, ["modelValue"]), __props.customAuditType === 3 ? (_openBlock(), _createElementBlock("span", _hoisted_9, "售后订单开启后需通过团队审核")) : _createCommentVNode("", true)])]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_radio_group, {
        modelValue: auditConditionInfo.isAuditCondition,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => auditConditionInfo.isAuditCondition = $event)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_radio, {
          label: 0
        }, {
          default: _withCtx(() => [_hoisted_14]),
          _: 1
        })]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_radio, {
          label: 1
        }, {
          default: _withCtx(() => [_hoisted_16]),
          _: 1
        }), _withDirectives(_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_el_checkbox, {
          modelValue: auditConditionInfo.isAuditOrderPrice,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => auditConditionInfo.isAuditOrderPrice = $event),
          "true-label": 1,
          "false-label": 0
        }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createVNode(_component_el_input_number, {
          modelValue: auditConditionInfo.orderLimitPrice,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => auditConditionInfo.orderLimitPrice = $event),
          size: "small",
          min: 0,
          precision: 2,
          style: {
            "margin": "0 10px"
          }
        }, null, 8, ["modelValue"]), _hoisted_21])]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_el_checkbox, {
          modelValue: auditConditionInfo.isAuditCustType,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => auditConditionInfo.isAuditCustType = $event),
          "true-label": 1,
          "false-label": 0
        }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_23, [_hoisted_24, _createVNode(_component_el_select, {
          class: "customer-type-select",
          modelValue: auditConditionInfo.custTypeList,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => auditConditionInfo.custTypeList = $event),
          multiple: "",
          filterable: "",
          "collapse-tags": "",
          "collapse-tags-tooltip": "",
          clearable: "",
          placeholder: "请选择客户类型"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customerTypeOptions.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_el_checkbox, {
          modelValue: auditConditionInfo.isAuditProdPrice,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => auditConditionInfo.isAuditProdPrice = $event),
          "true-label": 1,
          "false-label": 0
        }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_26, [_hoisted_27, _withDirectives(_createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          style: {
            "margin-left": "10px"
          },
          onClick: _cache[7] || (_cache[7] = $event => showAddProductModal.value = true)
        }, {
          default: _withCtx(() => [_hoisted_28]),
          _: 1
        }, 512), [[_vShow, auditConditionInfo.isAuditProdPrice]])])]), _hoisted_29], 512), [[_vShow, auditConditionInfo.isAuditCondition == 1]])])]),
        _: 1
      }, 8, ["modelValue"])]), _withDirectives(_createElementVNode("div", _hoisted_30, [_createVNode(_component_el_button, {
        type: "danger",
        icon: "Delete",
        size: "small",
        onClick: removeProdHandle
      }, {
        default: _withCtx(() => [_hoisted_31]),
        _: 1
      }), _hoisted_32, _createVNode(_component_el_table, {
        data: auditConditionInfo.prodInfoList,
        onSelectionChange: _cache[9] || (_cache[9] = list => selectedProdList.value = list),
        style: {
          "margin-top": "10px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }), _createVNode(_component_el_table_column, {
          prop: "branchName",
          label: "发货方"
        }), _createVNode(_component_el_table_column, {
          prop: "prodNo",
          label: "编码"
        }), _createVNode(_component_el_table_column, {
          prop: "prodName",
          label: "名称"
        }), _createVNode(_component_el_table_column, {
          prop: "prodLimitPrice",
          label: "审核金额"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_input_number, {
            modelValue: scope.row.prodLimitPrice,
            "onUpdate:modelValue": $event => scope.row.prodLimitPrice = $event,
            precision: 2,
            size: "small",
            min: 0
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "prodLimitNum",
          label: "审核数量"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_input_number, {
            modelValue: scope.row.prodLimitNum,
            "onUpdate:modelValue": $event => scope.row.prodLimitNum = $event,
            precision: 2,
            size: "small",
            min: 0
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "prodSpecification",
          label: "规格"
        }), _createVNode(_component_el_table_column, {
          prop: "manufacturer",
          label: "厂家"
        })]),
        _: 1
      }, 8, ["data"])], 512), [[_vShow, auditConditionInfo.isAuditCondition == 1 && auditConditionInfo.isAuditProdPrice]])]), _createElementVNode("div", _hoisted_33, [_hoisted_34, !auditParams.factorySupplierId ? (_openBlock(), _createBlock(_component_el_radio_group, {
        key: 0,
        modelValue: auditorConfigInfo.auditorType,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => auditorConfigInfo.auditorType = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: 1
        }, {
          default: _withCtx(() => [_hoisted_35]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: 0
        }, {
          default: _withCtx(() => [_hoisted_36]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), auditorConfigInfo.auditorType == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_hoisted_38, _createVNode(_component_el_radio_group, {
        modelValue: auditorConfigInfo.supplierAuditorType,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => auditorConfigInfo.supplierAuditorType = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: 1
        }, {
          default: _withCtx(() => [_hoisted_39]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: 2
        }, {
          default: _withCtx(() => [_hoisted_40]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: 3
        }, {
          default: _withCtx(() => [_hoisted_41]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _hoisted_42])) : (_openBlock(), _createElementBlock("div", _hoisted_43, [!auditParams.factorySupplierId ? (_openBlock(), _createBlock(_component_el_timeline, {
        key: 0
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(auditorConfigInfo.auditorInfoList, (item, i) => {
          return _openBlock(), _createBlock(_component_el_timeline_item, {
            key: i,
            icon: "bottom",
            color: "#409eff",
            size: "large"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: $event => addAuditPerson(item, i)
            }, {
              default: _withCtx(() => [_hoisted_46]),
              _: 2
            }, 1032, ["onClick"]), _createElementVNode("div", _hoisted_47, "审批人：" + _toDisplayString(item.userNames), 1)]), _createElementVNode("div", _hoisted_48, [i > 0 ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              size: "small",
              type: "danger",
              onClick: $event => removeAuditPersonLevel(i)
            }, {
              default: _withCtx(() => [_hoisted_49]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true), !auditParams.factorySupplierId && i === auditorConfigInfo.auditorInfoList.length - 1 ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              size: "small",
              type: "primary",
              onClick: $event => addAuditPersonLevel(item, i)
            }, {
              default: _withCtx(() => [_hoisted_50]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true)])])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(auditorConfigInfo.auditorInfoList, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          class: "person-item",
          key: i
        }, [_createElementVNode("div", _hoisted_51, [_createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: $event => addAuditPerson(item, i)
        }, {
          default: _withCtx(() => [_hoisted_52]),
          _: 2
        }, 1032, ["onClick"]), _createElementVNode("div", _hoisted_53, "审批人：" + _toDisplayString(item.userNames), 1)])]);
      }), 128))]))]), _createElementVNode("div", _hoisted_54, [_hoisted_55, _createElementVNode("div", _hoisted_56, [_createVNode(_component_el_button, {
        type: "primary",
        icon: "Plus",
        size: "small",
        onClick: _cache[12] || (_cache[12] = $event => showAddCustomerModal.value = true)
      }, {
        default: _withCtx(() => [_hoisted_57]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "danger",
        icon: "Delete",
        size: "small",
        onClick: removeWhitePerson
      }, {
        default: _withCtx(() => [_hoisted_58]),
        _: 1
      })]), _createVNode(_component_el_table, {
        data: whiteCustInfoList.value,
        style: {
          "margin-top": "10px"
        },
        onSelectionChange: _cache[13] || (_cache[13] = list => selectedWhiteCustList.value = list)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }), _createVNode(_component_el_table_column, {
          prop: "custId",
          label: "客户ID"
        }), _createVNode(_component_el_table_column, {
          prop: "custName",
          label: "客户名称"
        })]),
        _: 1
      }, 8, ["data"])])], 512), [[_vShow, orderAuditStatus.value]]), _createVNode(_component_el_row, {
        justify: "center",
        style: {
          "margin-top": "20px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          style: {
            "width": "200px"
          }
        }, {
          default: _withCtx(() => [_hoisted_59]),
          _: 1
        })]),
        _: 1
      }), _createVNode(AddSalesmanModal, {
        modelValue: auditPersonModalShow.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => auditPersonModalShow.value = $event),
        onSuccess: auditPersonSuccess,
        supplierId: __props.actDept.supplierId,
        auditParams: auditParams,
        mode: _unref(auditPersonModalMode),
        getAuditPersonFn: props.apiOverrides.getAuditPerson
      }, null, 8, ["modelValue", "supplierId", "mode", "getAuditPersonFn"]), _createVNode(AddProductModal, {
        supplierId: _unref(supplierId),
        auditParams: auditParams,
        modelValue: showAddProductModal.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => showAddProductModal.value = $event),
        onSuccess: addProductHandle
      }, null, 8, ["supplierId", "modelValue"]), _createVNode(AddCustomerModal, {
        supplierId: _unref(supplierId),
        auditParams: auditParams,
        modelValue: showAddCustomerModal.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => showAddCustomerModal.value = $event),
        onSuccess: addWhitePersonSuccess
      }, null, 8, ["supplierId", "modelValue"]), _createVNode(UploadModal, {
        option: uploadOption,
        modelValue: showUploadModel.value,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => showUploadModel.value = $event),
        onSuccess: _cache[18] || (_cache[18] = $event => unAuditTable.value.commitProxy('reload'))
      }, {
        help: _withCtx(() => [_hoisted_60, _hoisted_61, _hoisted_62, _hoisted_63]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        title: "警告",
        modelValue: errorModalShow.value,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => errorModalShow.value = $event),
        width: "700px",
        top: "100px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[19] || (_cache[19] = $event => errorModalShow.value = false)
        }, {
          default: _withCtx(() => [_hoisted_65]),
          _: 1
        })]),
        default: _withCtx(() => [_hoisted_64, _createVNode(_component_el_table, {
          data: errorModalData.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "订单号",
            prop: "orderCodeSplit"
          }), _createVNode(_component_el_table_column, {
            label: "下单人",
            prop: "linkMan"
          }), _createVNode(_component_el_table_column, {
            label: "下单时间",
            prop: "createOrderTime"
          }), _createVNode(_component_el_table_column, {
            label: "所属团队",
            prop: "supplierName"
          }), _createVNode(_component_el_table_column, {
            label: "待审核人",
            prop: "auditNames"
          })]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};